import React from 'react';
import { motion } from 'framer-motion';
import { Briefcase, Calendar, MapPin, ExternalLink } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';
import { Button } from '../ui/button';

const Experience = () => {
  const { experienceData } = useAppContext();

  return (
    <section id="experience" className="py-20 relative">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-12 text-center"
        >
          <h2 className="text-3xl font-bold mb-2 terminal-text">
            <span className="text-primary">{'>'}</span> Work Experience
          </h2>
          <div className="w-20 h-1 bg-primary mx-auto"></div>
        </motion.div>

        <div className="space-y-12 max-w-4xl mx-auto">
          {experienceData.map((job, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="relative"
            >
              <div className="bg-background/80 border border-border/50 rounded-lg p-6 shadow-lg hover:border-border/80 transition-all duration-300 card-hover">
                <div className="flex flex-col md:flex-row gap-6">
                  <div className="md:w-1/3">
                    <div className="flex items-center mb-4">
                      <div className="w-12 h-12 bg-secondary/20 rounded-full flex items-center justify-center mr-4">
                        <Briefcase className="h-6 w-6 text-primary" />
                      </div>
                      <div>
                        <h3 className="text-xl font-bold terminal-text">
                          {job.position}
                        </h3>
                        <h4 className="text-lg text-foreground/80">
                          {job.company}
                        </h4>
                      </div>
                    </div>
                    <div className="flex flex-wrap items-center gap-4 mb-4 text-sm text-foreground/60">
                      <div className="flex items-center">
                        <Calendar className="h-4 w-4 mr-2" />
                        <span>{job.duration}</span>
                      </div>
                      <div className="flex items-center">
                        <MapPin className="h-4 w-4 mr-2" />
                        <span>{job.location}</span>
                      </div>
                    </div>
                  </div>

                  <div className="md:w-2/3">
                    <p className="mb-4">{job.description}</p>
                    <div className="mb-4">
                      <h5 className="font-medium mb-2">Key Achievements:</h5>
                      <ul className="list-disc list-inside text-sm text-foreground/80 space-y-1">
                        {job.achievements.map((achievement, i) => (
                          <li key={i}>{achievement}</li>
                        ))}
                      </ul>
                    </div>
                    <div className="mb-4">
                      <h5 className="font-medium mb-2">Technologies Used:</h5>
                      <div className="flex flex-wrap gap-2">
                        {job.technologies.map((tech, i) => (
                          <span key={i} className="skill-tag text-xs">
                            {tech}
                          </span>
                        ))}
                      </div>
                    </div>
                    {/* <Button
                      variant="ghost"
                      className="text-primary hover:bg-primary/10"
                      size="sm"
                    >
                      View Details
                      <ExternalLink className="ml-2 h-3 w-3" />
                    </Button> */}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
